<template>
  <span>
    <smart-icon
      icon="mdi-run"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="activityType.toUpperCase() === 'RUNNING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-walk"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'WALKING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-swim"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'SWIMMING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-bike"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'BIKING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-ski-cross-country"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'NORDIC_WALKING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-yoga"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'PILATES'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-tennis"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'TENNIS'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-soccer"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'SOCCER'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-golf"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'GOLF'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-home-trainer"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'HOME_TRAINER'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-volleyball"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'VOLLEYBALL'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-badminton"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'BADMINTON'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-handball"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'HANDBALL'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-ski-cross-country"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'CROSS_COUNTRY_SKIING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-swim"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'SWIMMING_FRONTCRAWL'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-zodiac-aquarius"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'AQUA_RUNNING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-skate"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'ICE_SKATING' || activityType.toUpperCase() === 'SKATING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-jump-rope"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'ROPE_SKIPPING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-basketball"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'BASKETBALL'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-bike"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'CYCLING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-human-female-dance"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'DANCING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-swim"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'SWIMMING_BREASTSTROKE'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-rowing"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else-if="activityType.toUpperCase() === 'ROWING'"
      v-bind="$attrs"
    />
    <smart-icon
        icon="mdi-weight-lifter"
        :size="$attrs.size || 20"
        :height="$attrs.size || 20"
        :width="$attrs.size || 20"
        :iconColor="$attrs.iconColor||$color.coro.gray"
        v-else-if="activityType.toUpperCase() === 'BODY_WEIGHT_TRAINING'"
        v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-dumbbell"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-else
      v-bind="$attrs"
    />
  </span>
</template>

<script>
import SmartIcon from "./SmartIcon";

/**
 * Component ActivityIcon.vue
 *
 * @module ActivityIcon
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/ActivityIcon.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "ActivityIcon",
  components: { SmartIcon },
  props: {
    activityType: {
      type: String,
      default: (type) => {
        return "running"
      }
    },
  },
};
</script>
